<section id="plans-informations" class="section plans-informations">
    <div class="container is-fullhd">
        <div id="title" class="columns">
            <div class="column is-12">
                <h1>Garanta a sua hospedagem de férias, sem comprometer o seu orçamento, com pequenas parcelas mensais.</h1>
            </div>
        </div>
        <div class="plans-informations__cards">
            <div class="container plans-informations__cards-container">
                <div class="columns">
                    <div class="column">
                        <div class="columns is-multiline is-centered is-gapless" *ngFor="let itens of plansInformations">
                            <div *ngFor="let item of itens" [class]="item.containerClass">
                                <div *ngIf="item.flag" [class]="item.badgeClass.class">
                                    <app-svg-icon [class]="item.badgeClass.icon" icon="sash" fill="white"></app-svg-icon>
                                    <div [class]="item.badgeClass.text">
                                        <p>{{item.flag}}</p>
                                    </div>
                                </div>
                                <div class="plans-informations__cards-container__item">
                                    <div class="plans-informations__cards-container__item-column">
                                        <div class="plans-informations__cards-container__item-column__header">
                                            <div class="plans-informations__cards-container__item-column__header-icons">
                                                <app-svg-icon class="plans-informations__cards-container__item-column__header-icons__icon"
                                                              [icon]="item.icon"
                                                              fill="white">
                                                </app-svg-icon>
                                            </div>
                                            <div class="plans-informations__cards-container__item-column__header-title text-center">
                                                <h2>{{item.title}}</h2>
                                            </div>
                                        </div>
                                        <div class="plans-informations__cards-container__item-column__body">
                                            <div class="plans-informations__cards-container__item-column__body-plans">
                                                <h4>
                                                    <app-svg-icon icon="check" fill="#5CB030"></app-svg-icon>
                                                    {{item.plans}}
                                                </h4>
                                            </div>
                                            <div *ngFor="let modality of item.modalities" [class]="modality.class">
                                                <h4>
                                                    <app-svg-icon [class]="modality.iconClass"
                                                                  [icon]="modality.icon"
                                                                  [fill]="modality.fill">
                                                    </app-svg-icon>
                                                    {{modality.label}}
                                                </h4>
                                            </div>
                                        </div>
                                        <div class="plans-informations__cards-container__item-column__footer">
                                            <div *ngFor="let price of item.prices" [class]="price.class">
                                                <h4 class="plans-informations__cards-container__item-column__footer-title"> {{price.daily}} diárias | {{price.people}} pessoas </h4>
                                                <h4 class="plans-informations__cards-container__item-column__footer-price">
                                                    R$
                                                    <span>&nbsp;{{convertPrice(price.price | currency: 'BRL': '' : '1.2-2')}}&nbsp;</span>
                                                    /mês
                                                </h4>
                                            </div>
                                        </div>
                                        <button class="button is-primary is-outlined plans-informations__cards-container__item-column__button" (click)="goToCart()">Assine agora</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="button is-primary is-outlined plans-informations__cards-button" (click)="goToCart()">Assine agora</button>

        </div>
    </div>
</section>
